import { render, staticRenderFns } from "./StockAllCountDetail.vue?vue&type=template&id=10d878d4&scoped=true&"
import script from "./StockAllCountDetail.vue?vue&type=script&lang=js&"
export * from "./StockAllCountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d878d4",
  null
  
)

export default component.exports